import { bindActionCreators } from 'redux'


export const open_drawer = 'open_drawer';
export const close_drawer = 'close_drawer';

export const open_btm_drawer = 'open_btm_drawer';
export const close_btm_drawer = 'close_btm_drawer';

export const toggle_drawer_Fix = 'toggle_drawer_Fix';
export const toggle_drawer_Pin = 'toggle_drawer_Pin';

export const drawer_content = 'drawer_content';

export const drawer_Filters = 'drawer_Filters';


export const openDrawer = () =>({type:open_drawer})
export const closeDrawer = () =>({type:close_drawer})

export const openBtmDrawer = () =>({type:open_btm_drawer})
export const closeBtmDrawer = () =>({type:close_btm_drawer})


export const toggleDrawerPin = () =>({type:toggle_drawer_Pin}) 
export const toggleDrawerFix = () =>({type:toggle_drawer_Fix}) 


export const HandleDrawerContent = content =>({type:drawer_content, payload: content}) 
export const setPageFilters = content =>({type:drawer_Filters, payload: content}) 


function DrawerActions(dispatch) {
    return bindActionCreators(
        { openDrawer, closeDrawer, openBtmDrawer, closeBtmDrawer, toggleDrawerPin, toggleDrawerFix, HandleDrawerContent, setPageFilters }
        , dispatch)
}

export default DrawerActions;
  